"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _Card = require("./Card.styles");
var _excluded = ["interactive", "onClick", "onKeyDown"];
/**
 * @since 4.1.0
 */

var Card = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var interactive = _ref.interactive,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var defaultInnerRef = (0, _react.useRef)();
  var innerRef = forwardedRef || defaultInnerRef;

  /**
   * if the card is interactive and an onClick function was provided,
   *   execute that function if the user presses the Enter or Space key
   *   while the card has focus.
   */
  var keyDownCallback = function keyDownCallback(e) {
    // Only execute if the card itself was clicked, not one of its children.
    if (e.target !== innerRef.current) {
      return;
    }
    if (typeof onKeyDown === 'function') {
      onKeyDown(e);
    }
    if ((e.keyCode === _constants.KEY_CODES.ENTER || e.keyCode === _constants.KEY_CODES.SPACE) && typeof onClick === 'function') {
      onClick(e);
      e.preventDefault();
    }
  };
  var cardProps = Object.assign({
    interactive: interactive,
    onClick: onClick,
    onKeyDown: keyDownCallback,
    role: interactive ? 'button' : undefined,
    tabIndex: interactive ? 0 : undefined,
    ref: innerRef
  }, rest);
  return /*#__PURE__*/_react.default.createElement(_Card.StyledCard, cardProps);
});
exports.Card = Card;
Card.displayName = 'Card';
Card.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node,
  /**
   * This prop allows you to specify that a card should have no border.
   */
  appearance: _propTypes.default.oneOf(['default', 'borderless']),
  /** A `primary` card has a highlighted border, where as a `secondary` card does not. */
  cardType: _propTypes.default.oneOf(Object.values(_constants.CARD_TYPES)),
  /**
   * This integer determines whether we use a shadow/elevation (1) or no elevation (0).
   */
  cardElevation: _propTypes.default.oneOf([0, 1]),
  /**
   * Change the direction of the accent border of `"primary"` cards.
   */
  cardDirection: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  /**
   * Adds interactive styling to the card (hover, cursor pointer, etc).
   */
  interactive: _propTypes.default.bool,
  /**
   * Callback function that's called whenever you click on the card.
   *   Be sure to add `stopPropagation` to any clickable child elements
   *   (ex: buttons or links). If an onClick function is provided, it
   *   will also be executed when the user presses the space or enter key
   *   while the card is focused.
   */
  onClick: _propTypes.default.func,
  /**
   * Used for accessibility. If the Card's `interactive` prop is set,
   *   the `role` is set to `"button"` by default.
   */
  role: _propTypes.default.string
} : {};
Card.defaultProps = {
  appearance: 'default',
  cardType: _constants.CARD_TYPES.primary,
  cardElevation: 1,
  cardDirection: 'bottom'
};